<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" :width="size" :height="size" class="vue-material-icon" aria-hidden="true">
        <path :d="pathData"/>
    </svg>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';

    @Component({
        name: 'MaterialIcon',
    })
    export default class MaterialIcon extends Vue
    {
        @Prop({
            type: String,
            required: true,
        }) icon: string;

        @Prop({
            type: Number,
            default: 24,
            required: false,
        }) size: number;

        iconPathData: Record<string, string> = {
            'arrow_drop_down': 'M480-360 280-560h400L480-360Z',
            'close': 'm256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z',
            'done': 'M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z',
            'event': 'M580-240q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Z',
            'fingerprint': 'M130-574q-7-5-8.5-12.5T126-602q62-85 155.5-132T481-781q106 0 200 45.5T838-604q6 9 4 16t-8 12q-6 5-14 4.5t-14-8.5q-55-78-141.5-119.5T481-741q-97 0-182 41.5T158-580q-6 9-14 10t-14-4ZM594-81q-104-26-170-103.5T358-374q0-50 36-84t87-34q51 0 87 34t36 84q0 33 25 55.5t59 22.5q34 0 58-22.5t24-55.5q0-116-85-195t-203-79q-118 0-203 79t-85 194q0 24 4.5 60t21.5 84q3 9-.5 16T208-205q-8 3-15.5-.5T182-217q-15-39-21.5-77.5T154-374q0-133 96.5-223T481-687q135 0 232 90t97 223q0 50-35.5 83.5T688-257q-51 0-87.5-33.5T564-374q0-33-24.5-55.5T481-452q-34 0-58.5 22.5T398-374q0 97 57.5 162T604-121q9 3 12 10t1 15q-2 7-8 12t-15 3ZM260-783q-8 5-16 2.5T232-791q-4-8-2-14.5t10-11.5q56-30 117-46t124-16q64 0 125 15.5T724-819q9 5 10.5 12t-1.5 14q-3 7-10 11t-17-1q-53-27-109.5-41.5T481-839q-58 0-114 13.5T260-783ZM378-95q-59-62-90.5-126.5T256-374q0-91 66-153.5T481-590q93 0 160 62.5T708-374q0 9-5.5 14.5T688-354q-8 0-14-5.5t-6-14.5q0-75-55.5-125.5T481-550q-76 0-130.5 50.5T296-374q0 81 28 137.5T406-123q6 6 6 14t-6 14q-6 6-14 6t-14-6Zm302-68q-89 0-154.5-60T460-374q0-8 5.5-14t14.5-6q9 0 14.5 6t5.5 14q0 75 54 123t126 48q6 0 17-1t23-3q9-2 15.5 2.5T744-191q2 8-3 14t-13 8q-18 5-31.5 5.5t-16.5.5Z',
            'keyboard_arrow_down': 'M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z',
            'keyboard_arrow_left': 'M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z',
            'keyboard_arrow_right': 'M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z',
            'keyboard_arrow_up': 'M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z',
            'policy': 'M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 63-16.5 122.5T736-280L618-398q11-19 16.5-39.5T640-480q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47q21 0 41.5-5.5T560-342l129 128q-42 49-94.5 84T480-80Zm0-320q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Z',
        };

        get pathData(): string
        {
            return this.iconPathData[this.icon];
        }
    }
</script>